export const GET_ALL_CARELABEL = 'GET_ALL_CARELABEL';
export const IMPORT_LIBRARY = 'IMPORT_LIBRARY';
export const GET_ALL_CARELABEL_GROUP = 'GET_ALL_CARELABEL_GROUP';
export const GET_CARELABEL_GROUP_ID = 'GET_CARELABEL_GROUP_ID';
export const GET_ALL_TYPE_CARELABEL = 'GET_ALL_TYPE_CARELABEL';
export const GET_ALL_CARELABEL_GROUP_ID = 'GET_ALL_CARELABEL_GROUP_ID';
export const UNMOUNT_CARE_GROUP = 'UNMOUNT_CARE_GROUP';
export const UNMOUNT_CARE_LIBRARY = 'UNMOUNT_CARE_LIBRARY';
